import { useSyncExternalStore } from 'react';

/** Ayuda al bateador: ver la zona a la que apunta el lanzador. Ajustes; desactivada por defecto. */
const KEY = 'sportsarena.batterHelp';
let on = (() => {
  try {
    return typeof window !== 'undefined' && localStorage.getItem(KEY) === '1';
  } catch {
    return false;
  }
})();
const listeners = new Set<() => void>();
export const getBatterHelp = (): boolean => on;
export const setBatterHelp = (v: boolean): void => {
  on = v;
  try {
    localStorage.setItem(KEY, v ? '1' : '0');
  } catch {
    /* sin almacenamiento */
  }
  listeners.forEach((l) => l());
};
export const useBatterHelp = (): boolean =>
  useSyncExternalStore(
    (l) => {
      listeners.add(l);
      return () => listeners.delete(l);
    },
    getBatterHelp,
    getBatterHelp
  );
